import React from 'react'
import '../App.css'
const Background = () => {
  return (
    <div class="area fixed z-[-20]" >
    <ul class="circles">
    <li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li>
    </ul>
    </div>
  )
}

export default Background